import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    listRoot: {
      width: '100%',
    },
    divider: {
      marginTop: theme.spacing(),
      marginBottom: theme.spacing(),
    },
    listItemTextMultiline: {
      display: 'flex',
    },
    primaryText: {
      paddingRight: theme.spacing(0.5),
    },
  };
};
